module.exports = __webpack_public_path__ + "static/media/07.f0eb7145.jpg";